module.exports = __webpack_public_path__ + "static/media/additional_retreat_120.8b36a551.png";